
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/bibliodesk-nasze-ksiazki-na-polkach-u-innych",
      function () {
        return require("private-next-pages/docs/bibliodesk-nasze-ksiazki-na-polkach-u-innych.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/bibliodesk-nasze-ksiazki-na-polkach-u-innych"])
      });
    }
  